import camelcaseKeys from "camelcase-keys";

import {
  authorizedGet,
  authorizedPatch,
  authorizedPost,
} from "../../authorizedRequests";
import { CustomerFormValues } from "./CustomerForm";
import { Customer, CustomerSchema } from "./schema";

const deepCamelcaseKeys = (obj: any) => camelcaseKeys(obj, { deep: true });
export const createCustomer = async (
  values: CustomerFormValues,
): Promise<Customer> => {
  const res = await authorizedPost({
    url: "/v1/customers",
    body: {
      customer: values,
    },
  });
  const customer = CustomerSchema.parse(deepCamelcaseKeys(res.body.customer));
  return customer;
};

export const fetchCustomer = async (): Promise<Customer | null> => {
  try {
    const res = await authorizedGet({
      url: "/v1/customers",
    });
    const customer = CustomerSchema.parse(deepCamelcaseKeys(res.body.customer));
    return customer;
  } catch (e) {
    return null;
  }
};

export const updateCustomer = async (
  values: CustomerFormValues,
): Promise<Customer> => {
  const res = await authorizedPatch({
    url: "/v1/customers",
    body: {
      customer: values,
    },
  });
  const customer = CustomerSchema.parse(deepCamelcaseKeys(res.body.customer));
  return customer;
};
